module.exports = __webpack_public_path__ + "img/jinrong.f9368a4b.png";